export default "__VITE_ASSET__CzkdUKCS__"